import { Tab, Tabs, styled, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import TabButton from '../TabButton';
import MarketDetailsFilterTabContent from './MarketDetailsFilterTabContent';
import { Add } from '@material-ui/icons';
import { MarketDetailsFiltersTypes, ModalFormValues } from '../../../types';
import MarketDetailsModal from './MarketDetailsModal';
import { openPopup } from '../../../../../stateManagement/actions/popupActions';
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 6,
};

const StyledTabs = styled((props: any) => (
    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        display: 'none'
    },
});

const StyledTab = styled((props: any) => (
    <Tab disableRipple {...props} />
))(({ theme }) => ({
    textTransform: 'none',
    marginRight: '10px',
    borderRadius: '5px',
    padding: '0 10px',
    height: '40px',
    minHeight: '20px',
    border: '1px solid lightgray',
    color: 'gray',
    '&.Mui-selected': {
        border: '1px solid var(--coupon-dark-blue)',
        color: 'var(--coupon-dark-blue)',
        background: 'var(--coupon-light-blue)'
    },
    '&.Mui-focusVisible': {
        backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
}));

/**
 * This is general component for both location and outlet filter.
 * This function takes tabList is props and renders those tablist as headers
 * It shows the content of each tab by calling getAllOption function whenever tab changes
 * @param props 
 * @returns 
 */
function MarketDetailsFilters(props: MarketDetailsFiltersTypes) {
    const { tabsList, handleTabChange, currentTab, getTabContent, data, onSelect, combinedSelectedValues, loading, filterName, multiple,arbitraryList=["distributorDetails"],chipLimit,dataLimit, readOnly = false  } = props;
    const currentTabName = tabsList ? tabsList[currentTab] : "";
    const [options, setOptions] = useState<Array<{ label: string, value: string }>>([]);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [showValues, setShowValues] = useState<boolean>(false);

    const [formValues, setFormValues] = useState<ModalFormValues>({
        input: '',
        matched: [],
        unmatched: [],
    });

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues({ ...formValues, input: event.target.value });
    };

    const handleValidateClick = () => {
        const matchedOptions = options.filter(option => formValues.input.split(',').map(item => item.trim().toLowerCase()).includes(option.value.toLowerCase()));
        const unmatchedWords = formValues.input.split(',').map(item => item.trim().toLowerCase()).filter(word => !matchedOptions.some(option => option.value.toLowerCase() === word));
        const matchedValues = matchedOptions.map(option => option.value);
        setShowValues(true);
        setFormValues({ ...formValues, unmatched: unmatchedWords, matched: matchedValues });
        console.log("matchedValues: ", matchedValues, "unmatchedWords: ", unmatchedWords)
    };

    const handleSave = () => {
        setModalOpen(false);
        setShowValues(false);
        if(currentTabName==="outletCode"){
            const inputValues = formValues.input.split(',').map(value => value.trim());
            const numericalValues = inputValues.filter(value => /^[0-9]+$/.test(value));
            const length = numericalValues.length;
            const prevLength=data[currentTabName].length ?? 0
            if(dataLimit){
                if(prevLength+length>dataLimit){
                    openPopup("Error",`No. of outlet codes cannot be greater than ${dataLimit}`);
                    setFormValues({ input: '', matched: [], unmatched: [] });
                    return;
                }
            }
            const uniqueValues = new Set([...data[currentTabName], ...numericalValues]);
            const uniqueData = Array.from(uniqueValues).filter(value => value.trim() !== '');
            handleDataSelect(uniqueData)
        }else{
            const uniqueValues = new Set([...data[currentTabName], ...formValues.matched]);
            const uniqueData = Array.from(uniqueValues);
            handleDataSelect(uniqueData)
        }  
        setFormValues({ input: '', matched: [], unmatched: [] });
        // console.log(data[currentTabName]);
    };

    const handleDataSelect = (currentSelectedValues: string[]) => {
        onSelect && onSelect(currentSelectedValues, currentTabName);
    }

    const handleOpen = () => {
        setModalOpen(true);
    };
    const handleClose = () => {
        setModalOpen(false);
        setShowValues(false);
        setFormValues({ input: '', matched: [], unmatched: [] });
    };

    return (
        <div className="market-details-filters-wrapper">
            <div className="market-filters-header">
                <div className="market-filters-selector-tabs-wrapper">

                    <StyledTabs value={currentTab} onChange={handleTabChange} variant="scrollable">
                        {
                            tabsList?.map((name: string) => {
                                const numberOfSelectedItems = data[name] ? Array.isArray(data[name]) ? data[name].length : 1 : 0;
                                return <StyledTab key={name} label={<TabButton text={name} numberOfSelectedItems={numberOfSelectedItems} />} />
                            })
                        }
                    </StyledTabs>
                    {arbitraryList && arbitraryList.includes(currentTabName) ? (
                    <IconButton size="small" className="sku-group-selector-collapse-ToggleBtn" onClick={handleOpen}>
                        <Add className='sku-group-selector-collapse-ToggleBtn-icon add-btn' />
                    </IconButton>
                ) : null}
                   
                </div>
            </div>
            <div className='market-filters-content'>
                <MarketDetailsFilterTabContent
                    options={options}
                    setOptions={setOptions}
                    loading={loading}
                    getContent={getTabContent}
                    combinedSelectedValues={combinedSelectedValues}
                    selectedOptions={data?.[currentTabName]}
                    onSelect={handleDataSelect}
                    currentTabName={currentTabName}
                    filterName={filterName}
                    multiple={multiple}
                    chipLimit={chipLimit}
                    readOnly={readOnly}
                />
            </div>
            <MarketDetailsModal
                modalOpen={modalOpen}
                handleClose={handleClose}
                handleInputChange={handleInputChange}
                handleValidateClick={handleValidateClick}
                handleSave={handleSave}
                formValues={formValues}
                showValues={showValues}
                currentTabName={currentTabName}
            />
        </div>
    )
}

export default React.memo(MarketDetailsFilters)